import { Grid, Skeleton, Stack } from '@mui/material';
import React from 'react';

export const ReductionTargetSkeleton: React.FC = () => {
  return (
    <Grid container columnSpacing={2} rowSpacing={2} sx={{ marginLeft: '0 !important', width: '100%' }}>
      {/* Scope toggle group + reset button row */}
      <Grid item xs={12} sx={{ paddingLeft: '0 !important' }}>
        <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" useFlexGap>
          <Skeleton variant="rounded" height={40} sx={{ width: { xs: '100%', sm: 400 } }} />
          <Skeleton variant="rounded" height={37} sx={{ width: { xs: '100%', sm: 90 } }} />
        </Stack>
      </Grid>

      {/* Base year / target year / method info bar */}
      <Grid item xs={12} sx={{ paddingLeft: '0 !important' }}>
        <Skeleton variant="rounded" height={52} />
      </Grid>

      <Grid item xl={4} lg={4} md={4} sm={12} xs={12} sx={{ paddingLeft: '0 !important' }}>
        <Skeleton variant="rounded" height={150} />
      </Grid>
      <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
        <Skeleton variant="rounded" height={150} />
      </Grid>
      <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
        <Skeleton variant="rounded" height={150} />
      </Grid>

      <Grid item xl={12} lg={12} md={12} sm={12} xs={12} sx={{ paddingLeft: '0 !important' }}>
        <Skeleton variant="rounded" height={470} />
      </Grid>
    </Grid>
  );
};


